export default {
    search: {
      label: '',
      placeholder: 'PIN number',
      system: {
        name: 'search',
      },
      style: {
        title: {
          bold: false,
        },
      },
      value: '',
      errors: [],
      type: 'search',
      name: 'search',
      key: 'search-workers',
      rules: {
        title: '',
        required: false,
      }
    }
  }
  


// WEBPACK FOOTER //
// ./src/containers/CheckIn/fields.js